import { Validators } from '@angular/forms';
import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { validatePhoneNumberMaskedTextBox } from 'src/app/shared/validators/validator';

export const AddNewStudentFormModel: ISedmsFormModel = {
  firstName: {
    name: 'firstName',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  middleName: {
    name: 'middleName',
    required: false,
  },
  lastName: {
    name: 'lastName',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  dob: {
    name: 'dob',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  gender: {
    name: 'gender',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  studentEmail: {
    name: 'studentEmail',
  },
  studentPhoneNumber: {
    name: 'studentPhoneNumber',
    validators: [{ validator: validatePhoneNumberMaskedTextBox(false) }],
  },
  streetNumber: {
    name: 'streetNumber',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  streetName: {
    name: 'streetName',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  apartmentNumber: {
    name: 'apartmentNumber',
    required: false,
  },
  city: {
    name: 'city',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  homeBorough: {
    name: 'homeBorough',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  homeDistrict: {
    name: 'homeDistrict',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  state: {
    name: 'state',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  zip: {
    name: 'zip',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  guardianRelationship: {
    name: 'guardianRelationship',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  guardianFirstName: {
    name: 'guardianFirstName',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  guardianLastName: {
    name: 'guardianLastName',
    required: true,
    validators: [{ validator: Validators.required }],
  },
  guardianSpokenLanguage: {
    name: 'guardianSpokenLanguage',
  },
  guardianWrittenLanguage: {
    name: 'guardianWrittenLanguage',
  },
  guardianCellPhone: {
    name: 'guardianCellPhone',
    validators: [{ validator: validatePhoneNumberMaskedTextBox(false) }],
  },
  guardianWorkPhone: {
    name: 'guardianWorkPhone',
    validators: [{ validator: validatePhoneNumberMaskedTextBox(false) }],
  },
  guardianEmail: {
    name: 'guardianEmail',
  },
  guardianHomePhone: {
    name: 'guardianHomePhone',
    validators: [{ validator: validatePhoneNumberMaskedTextBox(false) }],
  },
  studentSk: {
    name: 'studentSk',
  },
};
